/**
 * ppt.service.ts — Layer 3: PowerPoint Presentation Domain
 */

import { getRequest, postRequest, postFormData, patchRequest, deleteRequest } from './http.service';
import {
  URL_PPT_TEMPLATES,
  URL_PPT_TEMPLATES_UPLOAD,
  URL_PPT_TEMPLATE_BY_ID,
  URL_PPT_TEMPLATE_SET_DEFAULT,
  URL_PPT_TEMPLATES_DEFAULT_BY_ORG,
  URL_PPT_TEMPLATE_REFRESH_URL,
  URL_GENERATE_PRESENTATION,
  URL_CLIENT_BY_ID,
} from './url.service';

/** Fetch all PowerPoint templates, unfiltered (caller filters by org) */
export const fetchPptTemplates = () => getRequest(URL_PPT_TEMPLATES);

/** Upload a PowerPoint template (create, or update when formData includes templateId) */
export const uploadPptTemplate = (formData: FormData) =>
  postFormData(URL_PPT_TEMPLATES_UPLOAD, formData);

/** Delete a PowerPoint template */
export const deletePptTemplate = (templateId: string) =>
  deleteRequest(URL_PPT_TEMPLATE_BY_ID(templateId));

/** Set or unset a PowerPoint template as the organisation's default */
export const setDefaultPptTemplate = (
  templateId: string,
  payload: Record<string, unknown>,
) => patchRequest(URL_PPT_TEMPLATE_SET_DEFAULT(templateId), payload);

/** Get the default PPT template for an organisation */
export const fetchDefaultPptTemplate = (orgId: string) =>
  getRequest(URL_PPT_TEMPLATES_DEFAULT_BY_ORG(orgId));

/** Get a fresh signed blob URL for a PPT template */
export const refreshPptTemplateUrl = (templateId: string) =>
  getRequest(URL_PPT_TEMPLATE_REFRESH_URL(templateId));

/** Generate a PowerPoint presentation from file note content */
export const generatePresentation = (payload: Record<string, unknown>) =>
  postRequest(URL_GENERATE_PRESENTATION, payload);

/** Fetch client name (used during presentation generation) */
export const fetchClientForPresentation = (clientId: string) =>
  getRequest(URL_CLIENT_BY_ID(clientId));
